import { AutogenModelMovementAssignCarrier, AutogenRowMovementAssignCarrier } from "./autogen/AutogenModelMovementAssignCarrier";

export class ModelMovementAssignCarrier extends AutogenModelMovementAssignCarrier<RowMovementAssignCarrier> {
    constructor() {
        super(RowMovementAssignCarrier);
    }
}

export class RowMovementAssignCarrier extends AutogenRowMovementAssignCarrier {
}